import { render } from "./TripInfo.vue?vue&type=template&id=3b13a00d&scoped=true"
import script from "./TripInfo.vue?vue&type=script&lang=js"
export * from "./TripInfo.vue?vue&type=script&lang=js"

import "./TripInfo.vue?vue&type=style&index=0&id=3b13a00d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b13a00d"]])

export default __exports__